import script from "./DevelopmentDocumentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DevelopmentDocumentsView.vue?vue&type=script&setup=true&lang=js"

import "./DevelopmentDocumentsView.vue?vue&type=style&index=0&id=ce3cbbba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce3cbbba"]])

export default __exports__